import NotFoundPage from "./NotFoundPage";
import { Route } from "react-router-dom";

const routes = {
  key: "NOT_FOUND",
  routes: ({ userScope }) => [
    <Route
      key={"not-found-page"}
      path="*"
      element={<NotFoundPage userScope={userScope} />}
    />,
  ],
};
export default routes;
